import { useState, useRef, useContext } from "react";
import { ChevronDownSvg } from "../../icons/Icon";
import DiscountCouponDisplayBar from "./DiscountCouponDisplayBar";
import { editDiscountEvent } from "../../events/DiscountEvents";
import { useEventContext } from "../../contexts/EventContextProvider";
import { viewDiscountEvent } from "../../events/DiscountEvents";
import { PlaceholderContext } from "../../contexts/Contexts";
import { Dialog } from "../modal/Dialog";

const getStateColor = (discounts, id) => {
    if (discounts && discounts[id]) {
        switch (true) {
            case discounts[id].deleted:
                return 'CollectionList_DeletedRow';
            case discounts[id].error:
                return 'CollectionList_ErrordRow';
            default:
                return null;
        }
    }
};
const CouponsListItem = ({ items, onCheck, checked }) => {

    const { state, eventDispatch } = useEventContext();
    const rows = useRef({});
    const placeholder = useContext(PlaceholderContext);

    const onShow = (e, id) => {
        eventDispatch(viewDiscountEvent(e, id));
    }
    const onDelete = (e, o) => {
        placeholder.openModal(<Dialog><div>Delete coupon "<b>{o.name}</b>" ?</div></Dialog>, {
            onApprove: (a) => {
                a.actions.close();
            }
        }, {
            heading: 'Confirm delete',
            message: ''
        })
    }
    return (
        <div className="filter-list">
            {items &&
                items.map((item) => {
                    var backgroundColor = getStateColor(state?.discounts, item.id) || ((checked[item.id]) ? 'CollectionList_SelectedRow' : '');
                    return (
                        <div key={`variant-tag-${item.id}`} className={`StickerItem ${backgroundColor}`}>
                            <div className="flex-column">
                                <div className="flex-row">
                                    <div className="col-1 flex-center">
                                        <label className="StickerItem_label">
                                            <div className="StickerItem_tag">
                                                <input
                                                    type="checkbox"
                                                    name="variant"
                                                    onChange={(e) => onCheck(e, item)}
                                                    checked={checked[item.id] || false}
                                                />
                                            </div>
                                        </label>
                                    </div>
                                    <div className="col-19 flex-middle">
                                        <div className="StickerItem_tag">
                                            <span>{item.name}</span>
                                        </div>
                                    </div>
                                    <div className="col-3 flex-middle">
                                        <div className="StickerItem_controls" >
                                            <button onClick={(e) => eventDispatch(editDiscountEvent(e, item.id))}><span>edit</span></button>
                                            <button onClick={(e) => onDelete(e, item)}><span>delete</span></button>
                                        </div>
                                    </div>
                                    <div className="col-1 flex-middle">
                                        <div className="StickerItem_controls" >
                                            <button onClick={(e) => onShow(e, item.id)}><span><ChevronDownSvg /></span></button>
                                        </div>
                                    </div>
                                </div>
                                <DiscountCouponDisplayBar id={item.id} ref={(current => { rows.current[item.id] = current })} />
                            </div>
                        </div>
                    );
                })}
        </div>
    );
}

export default CouponsListItem;